import * as React from 'react';
import { ACTION_ID, FIXED_DATES_LIST } from '../utils';
import type { DateRangePreset } from '../DatePicker.types';

export function DateRangeFixedPresets({
  customPresets,
  onSelectFixedDate,
  onSelectCustomDate,
}: {
  customPresets?: DateRangePreset[];
  onSelectFixedDate: (
    date: Exclude<ACTION_ID, ACTION_ID.CUSTOM_RANGE | ACTION_ID.SINGLE>
  ) => void;
  onSelectCustomDate: (label: string) => void;
}) {
  return (
    <div className='sui-p-2 sui-border-r sui-border-solid sui-border-gray-90'>
      {customPresets?.length
        ? customPresets.map((customPreset) => (
            <DatePresetButton
              key={`snap-ui-fixed-date-${customPreset.label}`}
              {...{
                customPresets,
                onSelectCustomDate,
                label: customPreset.label,
              }}
            />
          ))
        : FIXED_DATES_LIST.map((fixedDate) => (
            <DatePresetButton
              key={`snap-ui-fixed-date-${fixedDate.label}`}
              {...{
                customPresets,
                onSelectFixedDate,
                value: fixedDate.value,
                label: fixedDate.label,
              }}
            />
          ))}
    </div>
  );
}

const DatePresetButton = ({
  customPresets,
  label,
  value,
  onSelectCustomDate,
  onSelectFixedDate,
}: {
  customPresets?: DateRangePreset[];
  label: string;
  value?: Exclude<ACTION_ID, ACTION_ID.CUSTOM_RANGE | ACTION_ID.SINGLE>;
  onSelectFixedDate?: (
    date: Exclude<ACTION_ID, ACTION_ID.CUSTOM_RANGE | ACTION_ID.SINGLE>
  ) => void;
  onSelectCustomDate?: (label: string) => void;
}) => (
  <button
    data-testid={label?.toLowerCase()}
    className='sui-block sui-text-gray-40/100 sui-outline-none sui-bg-transparent sui-w-full sui-text-left sui-p-0 sui-mb-2 sui-border-0 sui-cursor-pointer sui-pr-2'
    type='button'
    onClick={() => {
      customPresets ? onSelectCustomDate(label) : onSelectFixedDate(value);
    }}
  >
    {label}
  </button>
);
